import { useEffect, useState } from "react";
import appointmentService from "../../services/agendaApi/appointment.service";
import dataListService from "../../services/generalApi/dataList.service";
import UsersManagementService from "../../services/userManagementApi/usersManagement.service";
import {
  Button,
  Checkbox,
  Search,
  SelectOption,
  TableColumns,
  TableColumnWidth,
} from "@veneer/core";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import {
  Data,
  FormFields,
  IGetLists,
  IPosIn,
  ISelectFormat,
} from "../../models/input/agendaApi/IPosIn";
import { useNavigate } from "react-router-dom";
import posManagementService from "../../services/agendaApi/posManagement.service";
import { useTranslation } from "react-i18next";
import brandsService from "../../services/surveyApi/brands.service";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";

export const columnsWidth: TableColumnWidth[] = [
  { columnId: "posCode" },
  { columnId: "subRegion" },
  { columnId: "company" },
  { columnId: "subRetail" },
  { columnId: "tier" },
  { columnId: "class" },
  { columnId: "online" },
  { columnId: "pointOfSale" },
  { columnId: "city" },
  { columnId: "format" },
  { columnId: "longitude" },
  { columnId: "latitude" },
  { columnId: "stratification" },
  { columnId: "active" },
  { columnId: "createdDate" },
  { columnId: "16" },
];

export const initialColum2 = [
  {
    id: "posCode",
    label: "posCode",
    sortable: true,
  },
  {
    id: "subRegion",
    label: "subRegion",
    sortable: true,
  },
  {
    id: "company",
    label: "company",
    sortable: true,
  },
  {
    id: "subRetail",
    label: "subRetail",
    sortable: true,
  },
  {
    id: "tier",
    label: "tier",
    sortable: true,
  },
  {
    id: "class",
    label: "class",
    sortable: true,
  },
  {
    id: "online",
    label: "online",
    sortable: true,
  },
  {
    id: "pointOfSale",
    label: "pointOfSale",
    sortable: true,
  },
  {
    id: "city",
    label: "city",
    sortable: true,
  },
  {
    id: "format",
    label: "format",
    sortable: true,
  },
  {
    id: "longitude",
    label: "longitude",
    sortable: true,
  },
  {
    id: "latitude",
    label: "latitude",
    sortable: true,
  },
  {
    id: "stratification",
    label: "stratification",
    sortable: true,
  },
  {
    id: "active",
    label: "active",
    sortable: true,
  },
  {
    id: "createdDate",
    label: "createdDate",
    sortable: true,
  },
  { id: "16", label: "" },
];

const initialStateForm: FormFields = {
  subretailId: [],
  pointOfSale: [],
  claseId: [],
  countryId: [],
  stateId: [],
  cityId: [],
  economyId: [],
  cnpj: [],
  posCode: [],
  brands: [],
};

export default function PointofSalesLogic() {
  const navigate = useNavigate();
  const [dataSubRetailList, setDataSubRetailList] = useState<ISelectFormat[]>(
    []
  );
  const [dataClassList, setDataClassList] = useState<ISelectFormat[]>([]);
  const [dataCountryList, setDataCountryList] = useState<ISelectFormat[]>([]);
  const [dataStateList, setDataStateList] = useState<ISelectFormat[]>([]);
  const [dataCityList, setDataCityList] = useState<ISelectFormat[]>([]);
  const [dataStratificationList, setDataStratificationList] = useState<
    ISelectFormat[]
  >([]);
  const [dataTODelete, setDataToDelete] = useState<Data>();
  const [loadingTable, setLoadingTable] = useState(true);
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonActivatePOS, setButtonActivatePOS] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [columns2, setColumns2] = useState<TableColumns[]>(initialColum2);
  const [dataFiltered, setDataFiltered] = useState<Data[]>([]);
  const [dataPOSInformationList, setDataPOSInformationList] = useState<Data[]>(
    []
  );
  const [aviableDeleteModal, setAviableDeleteModal] = useState<boolean>(false);
  const [optionsBrands, setOptionsBrands] = useState<SelectOption[]>([]);
  const [optionsBrandsCopy, setOptionsBrandsCopy] = useState<SelectOption[]>(
    []
  );
  const [valueBrands, setValueBrands] = useState<number[]>([]);
  const [currentDataSelect, SetCurrentDataSelect] = useState({
    dataSubRetailList: [],
    dataClassList: [],
    dataCountryList: [],
    dataStateList: [],
    dataCityList: [],
    dataStratification: [],
  });
  const [formPointOfSale, setFormPointOfSale] =
    useState<FormFields>(initialStateForm);
  const [formPointOfSaleUpdate, setFormPointOfSaleUpdate] =
    useState<FormFields>(initialStateForm);
  const [t] = useTranslation("global");

  const createFilter = (
    label: string,
    handlerClear: () => void,
    handlerFilter: (value: string) => void
  ) => (
    <div style={{ width: "80%" }}>
      <Search
        label={label}
        placeholder={`Buscar ${label}`}
        id={`table-filter-${label.replace(/\s+/g, "")}`}
        onClear={handlerClear}
        onChange={(e) => handlerFilter(e!.toString())}
      />
    </div>
  );

  useEffect(() => {
    if (dataPOSInformationList.length > 0) {
      const newData = initialColum2.map((item) => {
        if (item.id !== "" && item.id !== "16") {
          return {
            ...item,
            label: t(`posManagement.${item.id}`),
            filter: undefined,
          };
        }
        return item;
      });
      setColumns2(newData);
      mapDataToColumns(dataPOSInformationList, newData);
    } else {
      columns2.forEach((item) => {
        if (item.id !== "" && item.label !== "") {
          item.label = t(`posManagement.${item.id}`);
        }
      });
    }
  }, [t, dataPOSInformationList]);

  useEffect(() => {
    if (dataFiltered.length > 0) {
      const data: Data[] = mapDataToColumns(dataFiltered, initialColum2);
      setDataPOSInformationList(data);
    }
  }, [dataFiltered]);

  const handleClearFilter = (id: string) => {};

  const getSubRetail = () => {
    appointmentService.getSubretailList().then((r) => {
      try {
        const data = r.map((item: IGetLists) => {
          return {
            value: item.fieldID,
            label: item.fieldValue,
          };
        });
        SetCurrentDataSelect((prev) => {
          prev.dataSubRetailList = data;
          return prev;
        });
        setDataSubRetailList(data);
      } catch (error) {
        console.error("Error al cargar lista:", error);
      }
    });
  };

  const getCountryList = () => {
    dataListService.getCountryListBySubregion().then((r) => {
      try {
        const data = r.map((item: IGetLists) => {
          return {
            value: item.contryId,
            label: item.countryName,
          };
        });
        SetCurrentDataSelect((prev) => {
          prev.dataCountryList = data;
          return prev;
        });
        setDataCountryList(data);
      } catch (error) {
        console.error("Error al cargar lista:", error);
      }
    });
  };

  const getStatesList = (countryID: number) => {
    UsersManagementService.getStateList(countryID).then((r) => {
      try {
        const data = r.map((item: IGetLists) => {
          return {
            value: item.stateID,
            label: item.stateName,
          };
        });
        SetCurrentDataSelect((prev) => {
          prev.dataStateList = data;
          return prev;
        });
        setDataStateList(data);
      } catch (error) {
        console.error("Error al cargar lista:", error);
      }
    });
  };

  const getCityList = (StateID: number) => {
    UsersManagementService.getCityList(StateID).then((r) => {
      try {
        const data = r.map((item: IGetLists) => {
          return {
            value: item.cityID,
            label: item.cityName,
          };
        });
        SetCurrentDataSelect((prev) => {
          prev.dataCityList = data;
          return prev;
        });
        setDataCityList(data);
      } catch (error) {
        console.error("Error al cargar lista:", error);
      }
    });
  };
  const getStratificationList = () => {
    posManagementService
      .getStratificationListPos(languageID.value.toString())
      .then((r) => {
        try {
          const data = r.map((item: IGetLists) => {
            return {
              value: item.fieldID,
              label: item.fieldValue,
            };
          });
          SetCurrentDataSelect((prev) => {
            prev.dataStratification = data;
            return prev;
          });
          setDataStratificationList(data);
        } catch (error) {
          console.error("Error al cargar lista:", error);
        }
      });
  };

  const getClassList = () => {
    posManagementService
      .getClassListPos(languageID.value.toString())
      .then((r) => {
        try {
          const data = r.map((item: IGetLists) => {
            return {
              value: item.fieldID,
              label: item.fieldValue,
            };
          });
          SetCurrentDataSelect((prev) => {
            prev.dataClassList = data;
            return prev;
          });
          setDataClassList(data);
        } catch (error) {
          console.error("Error al cargar lista:", error);
        }
      });
  };

  const getBrandsData = () => {
    try {
      brandsService
        .getBrands()
        .then((r: IBrandDto[]) => {
          const brandOptions: SelectOption[] = r.map((brand) => ({
            value: Number(brand.brandID),
            label: brand.brandName ?? "",
          }));
          setOptionsBrands(brandOptions);
          setOptionsBrandsCopy(brandOptions);
        })
        .catch((e) => console.error());
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdatePointOfSale = (data: Data) => {
    const newData = {
      subretailId: [data.idSubRetail.toString()],
      pointOfSale: [data.pointofSale],
      claseId: [data.idClass.toString()],
      countryId: !data.online ? [data.idCountry.toString()] : [],
      stateId: !data.online ? [data.idState.toString()] : [],
      cityId: !data.online ? [data.idCity.toString()] : [],
      economyId: !data.online ? [data.idStratification.toString()] : [],
      cnpj: [data.cnpj?.toString() ?? ""],
      posCode: [data.posCode],
    };
    return navigate("/updatePOS", { state: { newData: newData, data: data } });
  };

  const handleFilterChange = (
    data: Data[],
    field: keyof Data,
    value: string
  ) => {
    const lowerCaseValue = value.toLowerCase();
    handleClearFilter("tier");
    const filterArray = dataFiltered.filter((element: Data) => {
      const elementValue = element[field]?.toString().toLowerCase() || "";
      return elementValue.includes(lowerCaseValue);
    });
    const newData: Data[] = mapDataToColumns(filterArray, initialColum2);
    setCurrentPage(1);
    setDataPOSInformationList(newData);
  };

  function mapDataToColumns(dataArray: Data[], columns: TableColumns[]): any[] {
    const columnIdToFieldMap: { [key: string]: keyof Data } = {
      posCode: "posCode",
      subRegion: "subRegion",
      company: "copanyName",
      subRetail: "subRetail",
      tier: "tier",
      class: "class",
      online: "online",
      pointOfSale: "pointofSale",
      city: "city",
      format: "posFormat",
      longitude: "longitude",
      latitude: "latitude",
      stratification: "stratification",
      createdDate: "createdDate",
    };

    return dataArray.map((data) => {
      const resultObject: { [key: string]: any } = {};

      columns.forEach((column) => {
        const field = columnIdToFieldMap[column.id];
        let value: string | number | React.ReactNode = "";

        if (field) {
          if (column.id !== "online") {
            value = data[field];
          } else {
            value = (
              <Checkbox
                className="registerSalePriceCheckbox"
                id="checkbox"
                value={"checked"}
                checked={data.online}
              />
            );
          }
          if (column.filter === undefined && column.id !== "online") {
            column.filter = createFilter(
              column.label,
              () => handleClearFilter(column.id),
              (value) => handleFilterChange(dataArray, field, value)
            );
          }
        } else {
          switch (column.id) {
            case "active":
              value = (
                <Checkbox
                  className="registerSalePriceCheckbox"
                  id="checkbox"
                  value={"checked"}
                  checked={data.active}
                  onChange={() => handlerDelete(data)}
                />
              );
              break;
            case "16":
              value = (
                <Button
                  onClick={() => handleUpdatePointOfSale(data)}
                  disabled={!data.active}
                >
                  {t("header.update")}
                </Button>
              );
              break;
            default:
              value = "";
              break;
          }
        }

        resultObject[column.id] = value;
      });
      return resultObject;
    });
  }

  const handlerDelete = (data: Data) => {
    setDataToDelete(data);
    setAviableDeleteModal(true);
    setButtonActivatePOS(data.active);
  };

  const getPOSInformationList = () => {
    posManagementService
      .getPOSInformationListPos(languageID.value.toString())
      .then(async (r) => {
        try {
          setDataFiltered(r);
        } catch (error) {
          console.error("Error al cargar lista:", error);
        } finally {
          setLoadingTable(false);
        }
      });
  };

  const insertPOS = (params: IPosIn, onResult?: (result: number) => void) => {
    setLoading(true);

    posManagementService
      .insertPOS(params)
      .then((r) => {
        if (r === 1) {
          setFormPointOfSale(initialStateForm);
        }
        onResult?.(r);
      })
      .catch((err) => {
        console.log("error ", err);
        onResult?.(0);
      })
      .finally(() => setLoading(false));
  };
  const updatePOS = (params: IPosIn) => {
    setLoading(true);
    setColumns2(initialColum2);
    setFormPointOfSaleUpdate(initialStateForm);
    posManagementService
      .updatePOS(params)
      .then((r) => {
        if (r === 1) {
          return navigate("/posManagement");
        }
      })
      .catch((err) => {
        console.log("error ", err);
      })
      .finally(() => setLoading(false));
  };
  const deletePOS = (params: IPosIn) => {
    setLoadingTable(true);
    posManagementService
      .updatePOS(params)
      .then((r) => {
        if (r === 1) {
          return getPOSInformationList();
        }
      })
      .catch((err) => {
        console.log("error ", err);
      })
      .finally(() => {
        setLoading(false);
        setAviableDeleteModal(false);
      });
  };

  const handleChangeSearch = (
    value: string,
    dataRef: ISelectFormat[],
    setData: React.Dispatch<React.SetStateAction<any[]>>
  ) => {
    const dataCopy = dataRef || [];
    const filterArray = dataCopy.filter((element: ISelectFormat) => {
      const lowerCaseValue = value.toLowerCase();
      const elementValue = element.value?.toString().toLowerCase() || "";
      const elementLabel = element.label?.toString().toLowerCase() || "";

      return (
        elementValue.includes(lowerCaseValue) ||
        elementLabel.includes(lowerCaseValue)
      );
    });

    setData(filterArray);
  };

  const onChange = ({ value: selectedValue }: { value: number }) => {
    const valueCopy = [...valueBrands];
    const isOptionSelected = valueCopy.includes(selectedValue);
    if (isOptionSelected) {
      const index = valueCopy.indexOf(selectedValue);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(selectedValue);
    }

    setValueBrands(valueCopy);
  };

  return {
    getSubRetail,
    getClassList,
    getCountryList,
    getStatesList,
    getCityList,
    getStratificationList,
    getPOSInformationList,
    insertPOS,
    dataSubRetailList,
    dataClassList,
    dataCountryList,
    dataStateList,
    dataCityList,
    dataStratificationList,
    dataPOSInformationList,
    loadingTable,
    loading,
    formPointOfSale,
    setFormPointOfSale,
    formPointOfSaleUpdate,
    setFormPointOfSaleUpdate,
    updatePOS,
    aviableDeleteModal,
    setAviableDeleteModal,
    handleChangeSearch,
    setDataStratificationList,
    currentDataSelect,
    setDataSubRetailList,
    setDataCityList,
    setDataClassList,
    setDataCountryList,
    setDataStateList,
    dataTODelete,
    deletePOS,
    currentPage,
    setCurrentPage,
    columns2,
    getBrandsData,
    valueBrands,
    optionsBrandsCopy,
    setOptionsBrands,
    optionsBrands,
    onChange,
    setValueBrands,
  };
}
